import { categories } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

interface CategoriesProps {
  onSelect: (genre: string) => void;
}

export default function Categories({ onSelect }: CategoriesProps) {
  return (
    <section id="categories" className="relative py-14 md:py-20 bg-accent-100/50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Categories 题材分类"
          title="按喜好，快速找到你的菜"
          desc="七大题材分类，覆盖主流与冷门优秀作品。点击任一分类即可在精选区查看对应作品。"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4 md:gap-5">
          {categories.map((c) => (
            <button
              key={c.name}
              type="button"
              onClick={() => onSelect(c.name)}
              className="group flex flex-col items-center text-center gap-2 p-5 rounded-2xl bg-background-50 border border-background-200 hover:border-accent-400 hover:-translate-y-1 transition-all cursor-pointer"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-700 group-hover:bg-accent-500 group-hover:text-foreground-950 transition-colors">
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <span className="text-sm md:text-base font-bold text-foreground-950">{c.name}</span>
              <span className="text-[11px] text-foreground-500 leading-snug">{c.desc}</span>
              <span className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-500 text-[11px] font-semibold">
                {c.count} 部
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}